import React, { useRef, useState } from "react";
import styles from "../FollowUpModal/FollowUpModalStyles.module.css";
import { Modal, ModalBody } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { useNavigate } from "react-router-dom";

export default function QuesNotInQueue() {
  const modalState = useSelector((state) => state.domain);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    advanceFilterModalToggle,
    updateSelectedAnswer,
    notificationsDataRecommend,
  } = bindActionCreators(Actions, dispatch);
  const onClickButtons = (e, key)=>{
    e.preventDefault();
    if(key==='trending'){
    navigate(`expertHome/trending`);
    }
    if(key==='open'){
    navigate(`expertHome/open`);
    }
    advanceFilterModalToggle({ bool: false, value: "" });
  }
  return (
    <Modal
      show={modalState.modalState}
      onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
      centered={true}
      size={"lg"}
      dialogClassName={styles.modalDialog}
    >
      <ModalBody>
        <div className="col-md-12 col-lg-12">
          <h2 className={`${styles.questionTextInAsk} mb-3`}>
            This Question has been removed from your queue and assigned to the
            next expert.
          </h2>
          <p className={styles.answerText} style={{ background: "none" }}>
            If you are still interested in answering this question:
          </p>
          <p className={styles.answerText} style={{ background: "none" }}>
            A) Navigate to <a href="" onClick={(e)=>onClickButtons(e,"open")}>Open</a> Questions and select Assigned to Others.
          </p>
          <p className={styles.answerText} style={{ background: "none" }}>
            B) If another expert has already answered this question, you can go
            to the <a href="" onClick={(e)=>onClickButtons(e,"trending")}>Trending</a> view and click on the Edit button to
            add your answer.
          </p>
          <div class="text-center mb-20 mt-2">
                        <button className={`${styles.cancelButton}` } onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>
                            Ok
                        </button>
                    </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
